module.exports = __webpack_public_path__ + "img/tatyana-tumanova.abc517a0.jpg";